import { dialog } from "../../nq-component";
import BaseFormPresenter from "../../base/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../usecases/object";

class OthersPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.findOthers();
  }

  async findOthers() {
    const response = await findObjectUseCase().execute("others");
    console.log("response", response);
    this.view.setState({ others: response });
  }

  formatLastName(name) {
    if (!name || typeof name !== "string") return "";

    return name
      .split(" ")
      .filter((part) => part.trim().length > 0)
      .map((part) => part[0]?.toUpperCase() + ".")
      .join(" ");
  }
  async handleSubmit(object, others) {
    dialog.close();
    const lastname = this.formatLastName(object?.lastName);
    const queueObject = {
      name: `${object?.firstName} ${lastname}`,
      status: "waiting",
      window: object?.name,
      reason: object?.reason,
    };
    // delete object.firstName;
    // delete object.lastName;
    // delete object.updated;
    // delete object.created;
    // delete object.id;
    // delete object.acl;
    // console.log("others", object);
    try {
      await upsertUseCase().execute("queue", queueObject);
      this.view.submissionSuccess();
      this.view.showSuccessSnackbar("Successfully saved!");
    } catch (error) {
      throw error;
    }
  }
}

export default OthersPresenter;
